import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

const GoToStoreButton = ({ visible, disabled, featured, noPadding }) => {
  const { t } = useContext(AppContext);
  const title = t('product', 'store.link');
  return (
    <S.StoreLink
      visible={visible}
      disabled={disabled}
      noPadding={noPadding}
      data-test="GoToStoreButton"
    >
      <S.LinkDesktop
        variant={featured ? 'default' : 'text'}
        color={featured ? 'positive' : 'link'}
      >
        {title}
      </S.LinkDesktop>
      <S.LinkMobile ariaLabel={title} color={featured ? 'positive' : 'link'}>
        <ChevronRight />
      </S.LinkMobile>
    </S.StoreLink>
  );
};

GoToStoreButton.propTypes = {
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  featured: PropTypes.bool,
  noPadding: PropTypes.bool,
};

GoToStoreButton.defaultProps = {
  featured: true,
  visible: false,
  disabled: false,
  noPadding: false,
};

export default memo(GoToStoreButton);
